import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

const persistedUserCompany = (() => {
  try {
    return JSON.parse(localStorage.getItem('userCompany')) || null
  } catch (e) {
    return null
  }
})()

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    'app-ecommerce': ecommerceStoreModule,
  },
  state: {
    userCompany: persistedUserCompany,
  },
  mutations: {
    selected_company(state, userCompany) {
      state.userCompany = userCompany
    },
  },
  strict: process.env.DEV,
})
